import { Layout } from "antd"
import styled from "styled-components"

const { Content } = Layout

export const DefaultContent = styled(Content)`
  background-color: #fff;
  width: 100%;
  min-height: 100%;
  margin-left: 240px;
`
